import { Clock, CalendarPlus, ArrowDownAZ, ArrowUp, ArrowDown } from 'lucide-react';
import { useUIStore, type ProjectSortMode } from '../stores/uiStore';

const modes: { mode: ProjectSortMode; label: string; icon: typeof Clock }[] = [
  { mode: 'last_accessed', label: 'Recent', icon: Clock },
  { mode: 'date_added', label: 'Added', icon: CalendarPlus },
  { mode: 'alphabetical', label: 'A-Z', icon: ArrowDownAZ },
];

export default function SortControl() {
  const sortMode = useUIStore((state) => state.projectSortMode);
  const setSortMode = useUIStore((state) => state.setProjectSortMode);
  const sortDir = useUIStore((state) => state.projectSortDir);
  const toggleDir = useUIStore((state) => state.toggleProjectSortDir);

  return (
    <div className="flex items-center gap-1">
      {modes.map(({ mode, label, icon: Icon }) => (
        <button
          key={mode}
          onClick={() => setSortMode(mode)}
          className={`btn btn-xs gap-1 ${
            sortMode === mode ? 'btn-primary btn-outline' : 'btn-ghost'
          }`}
          title={`Sort by ${label.toLowerCase()}`}
        >
          <Icon className="w-3 h-3" />
          {label}
        </button>
      ))}
      {/* Ascending ⇄ descending — reorders within each group */}
      <button
        onClick={toggleDir}
        className="btn btn-xs btn-ghost btn-square"
        title={sortDir === 'asc' ? 'Ascending — click for descending' : 'Descending — click for ascending'}
        aria-label={`Sort direction: ${sortDir === 'asc' ? 'ascending' : 'descending'}`}
      >
        {sortDir === 'asc' ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />}
      </button>
    </div>
  );
}
